<template>
    <div class="form">
        <h4 class="step-title">
            <label for="vehicleVin" v-bind:title="vehicle.make + ' ' + vehicle.model + ' vehicle identification number'">{{vehicle.make}} {{vehicle.model}} VIN</label>
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <ValidationObserver v-slot="{ errors, invalid, handleSubmit }" @submit.prevent>
                <div class="step-item">
                    <ValidationProvider mode="eager" vid="vehicleVin" name="VIN" rules="required|alpha_num|length:17">
                        <input id="vehicleVin" class="form-control min-content-width" placeholder="VIN" v-on:keyup.enter="enterKeyup" v-model="vehicle.vin">
                    </ValidationProvider>
                </div>
                <div class="step-item" v-if="errors['vehicleVin'] && errors['vehicleVin'].length > 0">
                    <div class="alert alert-danger">
                        <a href="https://en.wikipedia.org/wiki/Vehicle_identification_number" target="_blank">{{ errors["vehicleVin"][0] }}</a>
                    </div>
                </div>
                <div class="step-item">
                    <button class="btn step-btn form-control" ref="complete" v-on:click="handleSubmit(complete)">Continue</button>
                </div>
                <div class="step-item" v-if="appConfig.vinStepAllowSkip">
                    <button class="btn step-btn form-control" v-on:click="skip()">Skip</button>
                </div>
                <SlotInvalidInputWatchComponent v-bind:invalid="invalid" v-bind:value="vehicle.vin" v-on:invalidInput="onInvalidInput" />
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import { extend } from "vee-validate";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required, alpha_num, length } from "vee-validate/dist/rules";
    import SlotInvalidInputWatchComponent from "./shared/SlotInvalidInputWatchComponent.vue";

    extend("required", {
        ...required,
        message: "VIN is required."
    });

    extend("alpha_num", {
        ...alpha_num,
        message: "Invalid VIN."
    });

    extend("length", {
        ...length,
        message: "VIN must be 17 characters."
    });

    export default {
        name: "VehicleVin",
        components: {
            ValidationProvider,
            ValidationObserver,
            SlotInvalidInputWatchComponent
        },
        props: {
            lead: Object
        },
        computed: {
            vehicle: function () {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function() {
                this.$emit("complete", this.$options.name, this.vehicle.vin);
            },
            skip: function() {
                this.$emit("complete", this.$options.name, "skip");
            },
            onInvalidInput: function(value) {
                this.utils.log("onInvalidInput: " + value);
                this.$emit("invalidInput", this.$options.name, value);
            }
        }
    }
</script>
